import Vue from 'vue'
import Vuex from 'vuex'
import winType from "./modules/winType.js"
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    userInfo: {

    },//用户信息
    wechatType: '',//是否微信内
    deviceData:"",//设备信息
    isBindPhone: "0",
    iframeSize: {
      m_w: '',
      m_h: ''
    },
    agreement: {
      title: '',
      details: ''
    },//用户协议内容
    registerPwd:'',//注册的密码
    isPay:false,
    isSafariBrowser:false,//是否safari
    visibleGuideFloat:false,//是否开启下载框
    gameIconUrl:"",//游戏icon,
    serviceUrl:"",//客服链接,
    pwdLoginTitle:"账号登录",
    baseParams:{},
  },
  mutations: {
    postUserInfo(state, payload) {
      state.userInfo = payload;
    },
    postWechatType(state, payload) {
      state.wechatType = payload;
    },
    postDeviceData(state, payload) {
      state.deviceData=payload;
    },
    postBaseParams(state, payload) {
      state.baseParams=payload;
    },
    postIsBindPhone(state, payload) {
      // var userInfo={...state.userInfo};
      // userInfo.isBindPhone=payload;
      // state.userInfo = userInfo;
      state.userInfo.bindPhone = payload;
    },
    postFcm(state, payload) {
      state.userInfo.fcm = payload;
    },
    
    getIframeSize(state, payload) {
      state.iframeSize.m_w = payload.m_w;
      state.iframeSize.m_h = payload.m_h
    },
    postAgreement(state, payload) {
      state.agreement.title = payload.content
      state.agreement.details = payload.privacy
    },
   
    postBindPhoneShow(state, payload) {
      state.BindPhoneShow = payload;
    },
    postRegisterPwd(state, payload) {
      state.registerPwd = payload;
    },
    postIsSafariBrowser(state, payload) {
      state.isSafariBrowser = payload;
    },
    postVisibleGuideFloatr(state, payload) {
      state.visibleGuideFloat = payload;
    },
    postGameIconUrl(state, payload) {
      state.gameIconUrl = JSON.parse(payload);
    },
    //问题---监听loginOut后强制登出操作会导致跳转支付宝后也被强制等出，
    //解决方案---跳转支付宝之前设置isPay，当监听到loginOut并且isPay为true时(为跳转支付宝操作)不进行强制登出操作
    postIsPay(state, payload){
      state.isPay = payload;
    },
    postServiceUrl(state, payload) {
      state.serviceUrl = payload;
    },
    postPwdLoginTitle(state, payload) {
      state.pwdLoginTitle = payload;
    },
  },

  // getters
  getters: {


  },
  actions: {

  },
  modules: {
    winType,
  }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js